meedy.factory('meedy.agreementModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.agreementService',
    function($rootScope, applicationModel, baseModel, agreementService) {

        function AgreementModel() {

            var self = this;

            this.download = function(token) {
                agreementService.download(token).then(
                    function (dataPage) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.AGREEMENT.DOWNLOAD.SUCCESS, dataPage);
                    },
                    function(error) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.AGREEMENT.DOWNLOAD.ERROR, error);
                    }
                )
            };

        }

        return new AgreementModel();
    }
]);
